import { apiClient } from './client';

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  role: 'admin' | 'trainer' | 'learner';
  phone: string;
  age: number | null;
  gender: 'male' | 'female' | 'other' | '';
  city: string;
  village: string;
  district: string;
  language_pref: string;
  avatar_url: string;
  is_active: boolean;
  date_joined: string;
}

export interface RegisterPayload {
  email: string;
  password: string;
  full_name?: string;
  role?: string;
  language_pref?: string;
  phone?: string;
  age?: number | null;
  gender?: string;
  city?: string;
}

export const authApi = {
  register: (payload: RegisterPayload) =>
    apiClient.post<UserProfile>('/auth/register', payload),
  login: (identifier: string, password: string, role?: string) =>
    apiClient.post<UserProfile>('/auth/login', { identifier, password, role }),
  forgotPassword: (identifier: string) =>
    apiClient.post<{ detail: string }>('/auth/forgot-password', { identifier }),
  resetPassword: (identifier: string, otp: string, password: string) =>
    apiClient.post<{ detail: string }>('/auth/reset-password', { identifier, otp, password }),
  logout: () => apiClient.post('/auth/logout'),
  me: () => apiClient.get<UserProfile>('/auth/me'),
  updateProfile: (payload: Partial<UserProfile>) => apiClient.patch<UserProfile>('/auth/me', payload),
};
